import rawAllowlist from '../../../../sanitize.allowlist.json';
import { parseAllowlist } from './index.js';
/**
 * 浏览器 / Vite 侧的默认白名单加载入口。仓库根 JSON 会作为构建期资产进入 bundle，
 * 仍复用 `parseAllowlist` 做 Debug-First runtime 校验，不引入 filesystem fallback。
 */
export function loadAllowlist() {
    return parseAllowlist(rawAllowlist);
}
/**
 * 将项目共享 allowlist 转成 DOMPurify 基础配置。per-tag 属性、CSS 属性与 URI
 * scheme 的精确收窄由 RichText sanitizer hooks 继续执行。
 */
export function toDomPurifyConfig(allowlist) {
    return {
        ALLOWED_TAGS: [...allowlist.allowedTags],
        ALLOWED_ATTR: collectAllowedAttributes(allowlist),
        ALLOW_DATA_ATTR: allowsDataAttributes(allowlist),
        __allowlist: allowlist,
    };
}
function collectAllowedAttributes(allowlist) {
    const attrs = new Set();
    for (const values of Object.values(allowlist.allowedAttributes)) {
        for (const attr of values) {
            if (attr !== 'data-*') {
                attrs.add(attr);
            }
        }
    }
    return [...attrs].sort();
}
function allowsDataAttributes(allowlist) {
    return Object.values(allowlist.allowedAttributes).some((attrs) => attrs.includes('data-*'));
}
//# sourceMappingURL=dompurify.js.map